import Cookie from 'js-cookie';
import appConfig from '../appConfig';
import LoyaltyService from 'Service/LoyaltyService';
import { getBrowserCookie } from 'Utils/browserCookieUtils';
import jwtDecode from 'jwt-decode';

export const applicationKeys = {
  MobileIphone: 'BF448871-DB72-4CD7-A0E0-1F82BF410370',
  MobileAndroid: '8093F525-1BAC-49C0-8FB7-C9F7B2DA04CF',
  WebSite: 'AF7F2A37-CC4B-4F1C-87FD-FF3642F67ECB',
  MobileSite: 'D5BABFEB-AEE3-420B-9857-0697C8716A7E',
  MobileIpad: '8B497575-C938-4807-8060-130380F67F7C',
  BackOffice: 'DACEEFC8-68BC-40FB-B693-BC7198F42474',
  LegacyMobileApp: 'A0A16B0C-9FCE-48BB-8881-4AC263A938F3',
  KanalD: '71C6ED59-AA28-4852-8C7B-3FE28480E7EC'
};

export const applicationType = key => {
  if (
    key === applicationKeys.MobileIphone ||
    key === applicationKeys.MobileIpad ||
    key === applicationKeys.MobileAndroid ||
    key === applicationKeys.LegacyMobileApp
  ) {
    return 'Mobile';
  }
  return 'Site';
};

export const isHBNativeApp = () => {
  const appKey = Cookie.get('AppKey');
  return applicationType(appKey) === 'Mobile';
};

export const hBAppType = () => {
  const appKey = Cookie.get('AppKey');
  if (appKey === applicationKeys.MobileIphone || appKey === applicationKeys.MobileIpad) {
    return 'IOS';
  }
  if (appKey === applicationKeys.MobileAndroid) {
    return 'Android';
  }
  return 'Web';
};

export const createLink = url => {
  const anchor = document.createElement('a');
  anchor.setAttribute('hidden', true);
  anchor.href = url;
  document.body.appendChild(anchor);
  anchor.click();
};

export const triggerMobileDevice = (method, requestObject) => {
  if (window.webkit) {
    window.webkit.messageHandlers[method].postMessage(requestObject);
  } else if (window.Android) {
    window.Android[method](JSON.stringify(requestObject));
  }
};

export const getFullDate = date => {
  const event = new Date(date);
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const fullDate = event.toLocaleDateString('tr-TR', options);
  return fullDate;
};

export const getFullDateTime = date => {
  const event = new Date(date);
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };
  const fullDate = event.toLocaleDateString('tr-TR', options);

  if (fullDate.includes('01.01.1')) {
    return '--';
  }
  return fullDate;
};

export const attachEvent = (eventName, payload) => {
  const event = new CustomEvent(eventName, { payload });
  window.dispatchEvent(event);
};

export const getFullDateNumeric = date => {
  const event = new Date(date);
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
  const fullDate = event.toLocaleDateString('tr-TR', options);
  return fullDate;
};

export const appendHbBusScriptForNative = () => {
  if (!window.hepsiBus && isHBNativeApp()) {
    const hbBusScript = document.createElement('script');
    hbBusScript.src = 'https://images.hepsiburada.net/hbus/hbus.min.v3.8.57.js';
    document.head.appendChild(hbBusScript);
  }
};

export const htmlToPlainText = html => {
  return html.replace(/<[^>]+>/g, '');
};

export const getStaticPageId = url => {
  const urlObj = new URL(url);

  if (!url.toLocaleLowerCase().includes('staticpage')) {
    return null;
  }

  if (urlObj.searchParams.get('pageId')) {
    return urlObj.searchParams.get('pageId');
  }

  const STATIC_PAGE_ID_REGEX = /\d{3,}$/;
  if (STATIC_PAGE_ID_REGEX.test(url)) {
    const regexResp = url.match(STATIC_PAGE_ID_REGEX);
    return regexResp[0];
  }

  return null;
};

export const navigateNativeApp = url => {
  if (isHBNativeApp()) {
    createLink(`hbapp://staticpage?staticPageId=0000&url=${url}`);
    return;
  }
  window.location.href = url;
};

export const getVoltranUrl = value => {
  if (value.includes('voltran')) {
    return value.includes('preview') ? value.replace('preview', '') : value;
  }
  return null;
};

export const getBase64FromUrl = async url => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

export const mobileCheck = userAgent => {
  let isMobile = false;

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    isMobile = true;
  }

  return isMobile;
};

export const premiumCheckout = () => {
  const params = {
    productId: '6246e868e63d64b0ff6ad471'
  };
  LoyaltyService.openPremiumCheckout('', params)
    .then(response => {
      if (isHBNativeApp()) {
        createLink(`hbapp://cart?getUrl=${response.data?.url}`);
      } else {
        window.location.replace(response.data?.url);
      }
    })
    .catch(error => {
      const loginUrl = appConfig.loginUrl + encodeURIComponent(appConfig.redirectBasketUrl);

      if (error.response.status === 401 || error.status === 401) {
        if (isHBNativeApp()) {
          triggerMobileDevice('signin', {
            loginUrl
          });
        } else {
          window.location.href = appConfig.redirectBasketUrl;
        }
      } else {
        error.responseJSON.messages.map(data => {
          return window.hbToast.show({
            type: 'error',
            title: 'Hepsiburada Premium',
            message: data
          });
        });
      }
    });
};

export const checkSubscrptionInfo = async () => {
  if (!window?.loyaltyInfo && Cookie.get('jwt')) {
    const { data } = await LoyaltyService.getCustomerInfo();
    window.loyaltyInfo = data;
  }
};
export const parseJwt = token => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function(c) {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export const isLoginCheck = () => {
  const jwt = getBrowserCookie('jwt');
  const userDetail = jwt && parseJwt(jwt);
  return userDetail?.UserId?.length > 0;
};

export const getBoUser = () => {
  const jwt = getBrowserCookie('t_token_backoffice');
  const userDetail = jwt && parseJwt(jwt);
  return userDetail?.authUser;
};
export const getUserJWT = () => {
  return getBrowserCookie('jwt');
};
export const getBOJWT = () => {
  return getBrowserCookie('t_token_backoffice');
};

export const getCustomerInfo = () => {
  const jwtCookie = getUserJWT();
  if (!jwtCookie) {
    return false;
  }

  let customer = null;

  const jwtInfo = parseJwt(jwtCookie);

  if (jwtInfo) {
    customer = {
      ...jwtInfo,
      Application: applicationType(jwtInfo.AppKey)
    };
  }

  return customer;
};

export const getCustomer = () => {
  const customer =
    getCustomerInfo() || (Cookie.get('userInfo') ? JSON.parse(Cookie.get('userInfo')) : null);

  return {
    UserId: customer?.UserId || customer?.uid,
    Title: customer?.Title || customer?.t,
    FirstName: customer?.FirstName || customer?.fn,
    LastName: customer?.LastName || customer?.ln,
    Email: customer?.Email || customer?.e,
    AppKey: customer?.AppKey || customer?.ak,
    ...customer
  };
};

export const getCurrentBOUser = () => {
  const jwtCookie = getBOJWT();
  if (!jwtCookie) {
    return false;
  }
  return jwtDecode(jwtCookie);
};

export const checkRoles = allowedRoles => {
  const user = getCurrentBOUser();
  const userRoles = user?.authUser?.groups;

  const isAllowedForAll = allowedRoles?.includes('*');

  if (!userRoles || user?.iss === 'env:qa' || isAllowedForAll) {
    return true;
  }

  const isAllowed = allowedRoles.some(role => userRoles[role] === true);

  if (isAllowed) {
    return true;
  }

  return false;
};
